import * as React from 'react';
import Cross from '../icons/cross';
import styles from './modalWrapper.scss'
import TabNavigationHelper from '../../helpers/tabNavigationHelper';

function ModalWrapper(props: IModalWrapper) {

    const closeButtonRef = React.createRef<HTMLDivElement>();
    const tabNavigation: TabNavigationHelper = TabNavigationHelper.instance;

    React.useEffect(()=>{
        if(props.isOpen){
            tabNavigation.setFocusAtt(closeButtonRef.current);
            window.shell.tabNav.focus(closeButtonRef.current as Element);
        }
    })
    if (!props.isOpen) {
        return null;
    }
    return (
        <>
            <div className={styles.modal}>
                <div className={styles.modal_container} ref={(el) => tabNavigation.setModalAtt(el)}>
                    <div className={styles.modal_content}>
                        <div className={styles.modal_header}>
                            <div className={styles.modal_title}>
                                <div className={styles.title} dangerouslySetInnerHTML={{ __html: props.title }} />
                                {
                                    props.subtitle &&
                                    <div
                                        className={styles.subtitle}
                                        dangerouslySetInnerHTML={{ __html: props.subtitle }}
                                    />
                                }
                            </div>

                            <div className={styles.close_button} data-testid="close_button_header"
                              data-semantic-id="close_button_header"
                                onClick={props.onClose}
                                onKeyDown={tabNavigation.handleKeyDown}
                                ref={closeButtonRef}
                            >
                                <Cross />
                            </div>
                        </div>
                        <div className={styles.modal_body}>
                            {props.content}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ModalWrapper;

interface IModalWrapper {
    isOpen: boolean;
    title: string;
    subtitle?: string;
    content: React.ReactNode;
    onClose();
}

